var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 w-screen flex justify-center h-full"},[_c('Icon',{staticClass:"self-center",attrs:{"iconClass":"fas fa-spinner fa-pulse fa-6x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }